const conveniosPaciente = [
  {
    id: 1,
    label: '4) Convênio do paciente',
    name: 'convenio_sepse',
    opcoes: [
      {
        id: 1,
        descricao: 'Operadoras de saúde',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Particular',
        value: '2',
      },
      {
        id: 3,
        descricao: 'SUS',
        value: '3',
      },
    ],
  },
];

const comorbidades = [
  {
    id: 1,
    label: 'a) Imunossupressão',
    name: 'imuno_sepse',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 2,
    label: 'b) Neoplasia ativa',
    name: 'neoplasia_sepse',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 3,
    label: 'c) Acidente vascular cerebral',
    name: 'avc_sepse',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 4,
    label: `d) Cirrose`,
    name: 'cirrose_sepse',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 5,
    label: `e) Doença renal crônica`,
    name: 'drc_sepse',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 6,
    label: `f) Diabetes`,
    name: 'dm_sepse',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const dadosDaDoenca = [
  {
    id: 1,
    label: '6) Tipo de infecção',
    name: 'infeccao_sepse',
    opcoes: [
      {
        id: 1,
        descricao: 'Relacionada à assistência à saúde',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Comunitária',
        value: '0',
      },
    ],
  },
];

const gravidadeClinica = [
  {
    id: 1,
    label: '7) Gravidade da apresentação clínica',
    name: 'apre_clinica_sepse',
    opcoes: [
      {
        id: 1,
        descricao: 'Choque séptico',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Sepse',
        value: '0',
      },
    ],
  },
];

const sobreInicioSintomas = [
  {
    id: 1,
    label:
      '9) Sobre a data e hora do início dos sintomas de disfunção orgânica',
    name: 'sintomas_local_sepse',
    opcoes: [
      {
        id: 1,
        descricao:
          'Paciente foi admitido apresentando sinais de disfunção orgânica/sepse/choque séptico na chegada a instituição',
        value: '1',
      },
      {
        id: 2,
        descricao:
          'Paciente já estava internado e o horário da primeira disfunção orgânica foi registrado',
        value: '2',
      },
      {
        id: 3,
        descricao:
          'Paciente já estava internado e não foi possível identificar a data e hora da primeira disfunção',
        value: '99',
      },
    ],
  },
];

const reposicaoVolemicaAdequada = [
  {
    id: 1,
    label: '19) Paciente recebeu reposição volêmica adequada',
    name: 'rep_vol_realizacao_sepse',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
      {
        id: 3,
        descricao: 'Motivo clínico para não realização',
        value: '98',
      },
    ],
  },
];

const dataHoraReposicaoVolemica = [
  {
    id: 1,
    label: 'Data do início da reposição volêmica',
    name: 'rep_vol_data_sepse',
  },
  {
    id: 2,
    label: 'Hora do início da reposição volêmica',
    name: 'rep_vol_hora_sepse',
  },
];

const pressaoArterial = [
  {
    id: 1,
    label: 'Pressão arterial sistólica',
    name: 'pas_infusao_sepse',
  },
  {
    id: 2,
    label: 'Pressão arterial diastólica',
    name: 'pad_infusao_sepse',
  },
];

const medidaPressao = [
  {
    id: 1,
    label: 'Data da medida da pressão arterial após a reposição volêmica',
    name: 'pa_infusao_data_sepse',
  },
  {
    id: 2,
    label: 'Hora da medida da pressão arterial após a reposição volêmica',
    name: 'pa_infusao_hora_sepse',
  },
];

const infusaoVasopressor = [
  {
    id: 1,
    label: 'Data do início da infusão do vasopressor',
    name: 'vasop_data_sepse',
  },
  {
    id: 2,
    label: 'Hora do início da infusão do vasopressor',
    name: 'vasop_hora_sepse',
  },
];

const vasopressores = [
  {
    id: 1,
    label: '23) Paciente recebeu vasopressores',
    name: 'vasop_realizacao_sepse',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const covidSepse = [
  {
    id: 1,
    label: '27) Paciente teve diagnóstico de COVID-19 durante a internação',
    name: 'covid_sepse',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
      {
        id: 3,
        descricao: 'Não testado',
        value: '2',
      },
    ],
  },
];

const motivoSaida = [
  {
    id: 1,
    label: '28) Motivo da saída hospitalar',
    name: 'saida_motivo_sepse',
    opcoes: [
      {
        id: 1,
        descricao: 'Alta médica',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Óbito',
        value: '2',
      },
      {
        id: 3,
        descricao: 'Transferência',
        value: '3',
      },
      {
        id: 4,
        descricao: 'Evasão',
        value: '4',
      },
    ],
  },
];

const dataHoraSintomas = [
  {
    id: 1,
    label: 'Data do início dos sintomas de disfunção orgânica',
    name: 'sintomas_data_sepse',
  },
  {
    id: 2,
    label: 'Hora do início dos sintomas de disfunção orgânica',
    name: 'sintomas_hora_sepse',
  },
];

const dataHoraImpressao = [
  {
    id: 1,
    label:
      'Data da impressão diagnóstica de sepse ou choque séptico &nbsp; &nbsp; &nbsp; &nbsp; ',
    name: 'diagnostico_data_sepse',
  },
  {
    id: 2,
    label: 'Hora da impressão diagnóstica de sepse ou choque séptico',
    name: 'diagnostico_hora_sepse',
  },
];

const dataHoraRevisao = [
  {
    id: 1,
    label: 'Data da revisão da terapia antimicrobiana',
    name: 'revisao_data_sepse',
  },
  {
    id: 2,
    label: 'Hora da revisão da terapia antimicrobiana',
    name: 'revisao_hora_sepse',
  },
];

const dataHoraPrimeiraColeta = [
  {
    id: 1,
    label: 'Data da 1ª coleta de lactato sérico',
    name: 'lactato1_data_sepse',
  },
  {
    id: 2,
    label: 'Hora da 1ª coleta de lactato sérico',
    name: 'lactato1_hora_sepse',
  },
];

const dataHoraPrimeiraHemocultura = [
  {
    id: 1,
    label: 'Data da 1ª coleta de hemocultura',
    name: 'hemocultura_data_sepse',
  },
  {
    id: 2,
    label: 'Hora da 1ª coleta de hemocultura',
    name: 'hemocultura_hora_sepse',
  },
];

const dataHoraSegundaColeta = [
  {
    id: 1,
    label: 'Data da 2ª coleta de lactato sérico',
    name: 'lactato2_data_sepse',
  },
  {
    id: 2,
    label: 'Hora da 2ª coleta de lactato sérico',
    name: 'lactato2_hora_sepse',
  },
];

const dataHoraAntimicrobiano = [
  {
    id: 1,
    label:
      'Data da 1ª dose de antimicrobiano após a suspeita de sepse ou choque séptico',
    name: 'antimicrobiano_data_sepse',
  },
  {
    id: 2,
    label:
      'Hora da 1ª dose de antimicrobiano após a suspeita de sepse ou choque séptico',
    name: 'antimicrobiano_hora_sepse',
  },
];

const dataHoraSaida = [
  {
    id: 1,
    label: 'Data da saída',
    name: 'saida_data_sepse',
  },
  {
    id: 2,
    label: 'Hora da saída',
    name: 'saida_hora_sepse',
  },
];

export {
  conveniosPaciente,
  comorbidades,
  dadosDaDoenca,
  gravidadeClinica,
  sobreInicioSintomas,
  dataHoraRevisao,
  dataHoraImpressao,
  dataHoraSintomas,
  dataHoraPrimeiraColeta,
  dataHoraSegundaColeta,
  dataHoraPrimeiraHemocultura,
  dataHoraAntimicrobiano,
  dataHoraSaida,
  reposicaoVolemicaAdequada,
  dataHoraReposicaoVolemica,
  covidSepse,
  vasopressores,
  infusaoVasopressor,
  medidaPressao,
  pressaoArterial,
  motivoSaida,
};
